import {
  PaginationRequest
} from '../config/common';

export class PaginationSupplierRequest extends PaginationRequest {
  name?: string = '';
  email?: string = '';
  volumetricFigure?: string = '';
}

export interface CreateSupplierRequest {
  name?: string;
  email?: string;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  town?: string;
  county?: string;
  postcode?: string;
  phoneNo?: string;
  secondaryPhoneNo?: string;
  volumetricFigure?: string;
  costingType?: number;
  integrationEnabled?: boolean;
}

export interface SupplierCostUpdate {
  costingMethod?: number,
    pencePerUnit?: number,
    baseRate1?: number,
    baseRate2?: number,
    baseRate3?: number,
    maxAddPer1kg?: number
}

export interface AvailableServiceBoxRatesUpdate {
  serviceLevel?: string,
  firstBoxPrice?: number,
  subsequentBoxes?: number,
  saturdayDelivery?: true,
  sundayDelivery?: true,
  maxBoxLength?: number,
  maxBoxLengthAndWidth?: number,
  maxBoxWeight?: number,
  supplierCostID?: string
}

export interface ZonalSurchargesUpdate {
  serviceLevel?: string,
  zone2Percent?: number,
  zone2Min?: number,
  zone3Percent?: number,
  zone3Min?: number,
  supplierCostID?: string
}

export interface AvailableServiceConsignmentsUpdate {
    zone?: string,
    service?: string,
    baseRate1Cost?: number,
    baseRate2Cost?: number,
    baseRate3Cost?: number,
    addPerKg1Cost?: number,
    addPerKg2Cost?: number,
    addPerKg3Cost?: number,
    addPerKg4Cost?: number,
    limitMaxLength?: number,
    limitMaxWidth?: number,
    limitMaxHeight?: number,
    limitMaxWeight?: number,
    limitMaxConWeight?: number,
    supplierCostID?: string
}

export interface SupplierSurchargesUpdate {
    supplierID?: string,
    surchargeID?: string,
    costPrice?: number
}
